<template>
  <div id="home">

    <div class="content">
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div class="title">
          Account List
        </div>
        <div><span class="btn" @click="show_create">+ Create</span></div>
      </div>

      <el-table
        v-loading="table_loading"
        :data="tableData"
        :header-cell-style="{ fontSize: '14px', backgroundColor: '#F8F9FA',color:'#4A5468',fontWeight:'normal'}"
        :cell-style="{ fontSize: '14px'}"
        style="width: 100%;">

        <el-table-column
              type="index"
              width="50"
              label="#">
            </el-table-column>

        <el-table-column
          align="center"
          prop="login_email"
          min-width="180"
          label="Email">
        </el-table-column>

        <el-table-column
          align="center"
          min-width="150"
          label="type">
          <template slot-scope="scope">
            {{scope.row.account_type == "MAIN"?"Administrator":"Standard User"}}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          min-width="120"
          label="Date">
          <template slot-scope="scope" v-if="scope.row.created_datetime">
            {{moment(scope.row.created_datetime).format('MM/DD/YY')}}
          </template>
        </el-table-column>

        <el-table-column
          label="Action"
          align="center"
          min-width="100">
          <template slot-scope="scope">
            <el-link type="primary" title="Edit Account" @click.stop="show_edit(scope.row.client_account_uuid, scope.row.account_type)"><i class="font-size-16 el-icon-edit-outline"></i></el-link>
            <el-link type="primary" title="Reset password" @click.stop="reset_info(scope.row.client_account_uuid)" style="margin-left:10px;"><i class="font-size-16 el-icon-lock"></i></el-link>
            <el-link type="primary" title="Delete Account" @click.stop="delete_info(scope.row.client_account_uuid)" style="margin-left:10px;"><i class="font-size-16 el-icon-delete"></i></el-link>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="pager">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="page_size"
          :total="totalRows">
        </el-pagination>
      </div> -->
      <add ref="addForm" @ok="getDatas()"></add>
      <edit ref="editForm" @ok="getDatas()"></edit>
      <reset ref="resetForm"></reset>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getActionApi,deleteActionApi } from '@/network/manageApi';
  import Add from './account/Add'
  import Edit from './account/Edit'
  import Reset from './account/Reset'
  import moment from 'moment/moment';
  export default {
    name: 'AccountList',
    components: {
      Add,Edit,Reset
    },
    data() {
      return {
        totalRows: 0,
        current_page: 1,
        page_size: 10,
        tableData: [],
        table_loading: false,
      }
    },
    computed: {

    },
    mounted() {

    },
    created(){
      this.getDatas()
    },
    methods:{
      reset_info(id) {
        this.$refs.resetForm.init(id)
      },
      show_create() {
        this.$refs.addForm.init()
      },
      moment,
      show_edit(id,type) {
        this.$refs.editForm.init(id,type)
      },
      rowClick(row){
        this.$refs.viewForm.init(row.client_map_grid_uuid,row.competitor_list)
      },
      getDatas() {
        this.table_loading = true
        getActionApi("/user-management/accounts").then((res) => {
          this.tableData = res.data
        }).catch((err) => {
          this.$message.error(err.response.data.details.data.message);
        }).finally((res) => {
          this.table_loading = false
        })
      },
      delete_info(id){
        const that = this
        this.$confirm('Do you want to delete it??', 'confirm', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning',
          center: true
        }).then(() => {
          that.table_loading = true
          deleteActionApi("/user-management/accounts", {client_account_uuid: id}).then((res) => {
            that.$message({
              type: 'success',
              message: 'delete success!'
            });
            that.getDatas()
          }).catch((err) => {
            that.$message.error(err.response.data.details.data.message);
          }).finally((res) => {
            that.table_loading = false
          })

        })
      },
      handleCurrentChange(val) {
        this.getDatas(val)
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;word-break:normal;}
  #home{background-color:#F8F9FA;padding:20px;display: grid;gap: 20px;}
  .content{background-color: #ffffff;padding: 30px;display: grid;gap: 20px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);border-radius: 16px;}
  .title{color:#2D3648;font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;align-items: center;}
  .title div{display: flex;align-items: center;}
  .title div *{padding:10px 16px;font-size: 14px;}
  .pager{display: flex;justify-content: center;}
  .font-size-16 {font-size: 20px;}
  .margin-top-switch {margin-top: 10px;}
  .btn{height:40px;width:86px;cursor: pointer;background-color: #5856D6;color:#ffffff;border-radius: 6px;font-size: 14px;display: flex;align-items: center;justify-content: center;}
  .avatar-uploader-icon {font-size: 18px;color: #8c939d;}
  .headImageShow {width: 76px;height: 76px;border-radius: 4px;}
  @media (max-width: 768px) {
    .title{flex-direction: column;}
    .title div{margin-top:20px;}
    .center{display: flex;justify-content: center;}
    .content{padding:20px 5px;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {

  }
</style>
